import React from 'react';

export function Footer (){

    return (    
      <div className="footer">
          <div className="pull-right">
          <strong>Do-It &copy; 2019 </strong> All rights
          reserved.
          </div>          
      </div>
    )
}
